import SupervisingShiftLayout from "@/app/(app)/(crew)/supervising/[shift]/_layout";

export default SupervisingShiftLayout;
